import React from 'react';
import { motion } from 'framer-motion';
export function TwoOptions() {
  return <section className="py-14 md:py-20 bg-surface" data-id="element-304">
      <div className="container mx-auto px-5 md:px-6" data-id="element-305">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-306">
          <h2 className="text-2xl sm:text-3xl md:text-5xl mb-3" data-id="element-307">
            TODAVÍA TENÉS{' '}
            <span className="text-primary italic" data-id="element-308">DOS OPCIONES</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto mb-10 md:mb-14" data-id="element-309">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-background rounded-2xl p-5 md:p-8 border border-surface-light relative overflow-hidden" data-id="element-310">
            <div className="absolute top-0 left-0 w-full h-1 bg-surface-light" data-id="element-311" />
            <h3 className="text-xs md:text-sm font-bold tracking-widest text-text-muted mb-3 md:mb-5 uppercase" data-id="element-312">
              Opción 1
            </h3>
            <p className="text-base md:text-xl text-text-muted leading-relaxed" data-id="element-313">
              Seguir haciendo las cosas como hasta ahora y continuar sin saber
              exactamente cuánto dinero gana tu negocio.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} whileHover={{
          y: -3
        }} className="bg-primary/10 rounded-2xl p-5 md:p-8 border border-primary/30 relative overflow-hidden" data-id="element-314">
            <div className="absolute top-0 left-0 w-full h-1 bg-primary" data-id="element-315" />
            <h3 className="text-xs md:text-sm font-bold tracking-widest text-primary mb-3 md:mb-5 uppercase" data-id="element-316">
              Opción 2
            </h3>
            <p className="text-base md:text-xl text-white font-medium leading-relaxed" data-id="element-317">
              Implementar un sistema probado para recuperar el control de tus
              finanzas, organizar tus números y construir un negocio más
              rentable y estable.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-318">
          <p className="text-2xl md:text-3xl font-serif text-white" data-id="element-319">
            LA DECISIÓN ES TUYA.
          </p>
        </motion.div>
      </div>
    </section>;
}